var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c(
        "v-toolbar",
        { attrs: { color: "primary", dense: "", dark: "", elevation: "0" } },
        [
          _c("span", [_vm._v("Stocks")]),
          _c("v-spacer"),
          _c("v-icon", [_vm._v("mdi-table")])
        ],
        1
      ),
      _c("v-data-table", {
        attrs: {
          items: _vm.stockList,
          headers: _vm.headers,
          dense: "",
          loading: _vm.stockGetting,
          search: _vm.search
        },
        scopedSlots: _vm._u([
          {
            key: "top",
            fn: function() {
              return [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "3" } },
                      [
                        _c("v-text-field", {
                          attrs: {
                            label: "search",
                            "append-icon": "mdi-magnify"
                          },
                          model: {
                            value: _vm.search,
                            callback: function($$v) {
                              _vm.search = $$v
                            },
                            expression: "search"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            },
            proxy: true
          },
          {
            key: "item",
            fn: function({ item }) {
              return [
                _c("tr", [
                  _c("td", [_vm._v(_vm._s(item.id))]),
                  _c("td", [_vm._v(_vm._s(item.stock_category_id))]),
                  _c("td", [_vm._v(_vm._s(item.product_name))]),
                  _c("td", [_vm._v(_vm._s(item.product_type))]),
                  _c("td", [_vm._v(_vm._s(item.brand_name))]),
                  _c("td", [_vm._v(_vm._s(item.description))]),
                  _c(
                    "td",
                    [
                      _c(
                        "base-tooltip",
                        {
                          attrs: {
                            text: "",
                            "x-small": "",
                            color: "green",
                            tooltip: "srp unit",
                            bottom: ""
                          },
                          on: {
                            click: function($event) {
                              return _vm.$emit("update:stock-id", item.id)
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("mdi-hand-coin")])],
                        1
                      ),
                      _c(
                        "base-tooltip",
                        {
                          attrs: {
                            text: "",
                            "x-small": "",
                            color: "yellow darken-3",
                            tooltip: "edit",
                            bottom: ""
                          },
                          on: {
                            click: function($event) {
                              return _vm.$emit("edit", item)
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("mdi-pencil")])],
                        1
                      ),
                      !item.feed_detail_count
                        ? _c(
                            "base-tooltip",
                            {
                              attrs: {
                                text: "",
                                bottom: "",
                                "x-small": "",
                                color: item.default_detail
                                  ? "blue darken-1"
                                  : "blue-grey darken-4",
                                tooltip: "price"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.openStockDetailDialog(
                                    item.default_detail
                                      ? item.default_detail
                                      : { stockId: item.id }
                                  )
                                }
                              }
                            },
                            [
                              _c("v-icon", [
                                _vm._v("mdi-folder-search-outline")
                              ])
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ])
              ]
            }
          }
        ])
      }),
      _c(
        "v-dialog",
        {
          attrs: { eager: "", width: "20vw" },
          model: {
            value: _vm.stockDetailDialog,
            callback: function($$v) {
              _vm.stockDetailDialog = $$v
            },
            expression: "stockDetailDialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                {
                  attrs: {
                    color: "primary",
                    dense: "",
                    dark: "",
                    elevation: "0"
                  }
                },
                [_c("span", [_vm._v("Default Detail")])]
              ),
              _c(
                "v-container",
                [
                  _c("create-default-detail", {
                    on: {
                      close: function($event) {
                        _vm.stockDetailDialog = false
                      }
                    },
                    model: {
                      value: _vm.defaultDetailData,
                      callback: function($$v) {
                        _vm.defaultDetailData = $$v
                      },
                      expression: "defaultDetailData"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }